import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import LinkButton from "components/ui/LinkButton";

function ErrorPageNotFound() {
    return (
        <GridColumn>
            <GridItem>
                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"} style={{ textAlign: "center" }}>
                        <h1>Pagina non trovata</h1>

                        <p>La pagina richiesta non esiste.</p>
                    </GridItem>
                </GridRow>

                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"}>
                        <LinkButton
                            variant={"contained"}
                            to={"/dashboard"}
                            label={"Ritorna alla dashboard"}
                        />
                    </GridItem>
                </GridRow>
            </GridItem>
        </GridColumn>
    );
}

export default ErrorPageNotFound;
